import { createLogger } from "./logger.js";
import { services } from "../service-provider/ServiceRegistry.js";
import { USER_COLLECTION, update } from "../db/indexDB.js";
//#region src/helper/refresh-id-token.ts
var userLogger = createLogger("PdUserAuth");
/**
* Update token for user, so the service worker is up to date.
*/
var refreshAndPersistUserIdToken = async () => {
	try {
		const userToken = await services.auth.getIdToken(true);
		const user = services.auth.getCurrentUser();
		if (!userToken) {
			userLogger.warn("Token refresh skipped: no valid userToken returned.");
			return false;
		}
		const userName = user?.displayName || "";
		const appName = "pd-spa-helper";
		await update(USER_COLLECTION, {
			id: appName,
			userNameToken: userName,
			userIdToken: userToken
		});
		userLogger.info(`[TokenRefresh] ID Token refreshed & saved to local DB for app: ${appName}`);
		return true;
	} catch (error) {
		userLogger.error(`[TokenRefresh] Failed to refresh and persist token:`, error);
		return false;
	}
};
//#endregion
export { refreshAndPersistUserIdToken };
